import CityLanding from "@/pages/CityLanding";

const CITY = {
    slug: "orangepark",
    name: "Orange Park",
    shortName: "OP",
    zipHint: "Clay County — 32003, 32065, 32073",
    landmarkPhrase: "your home in Eagle Harbor or an office off Wells Road",
    introCopy:
        "Orange Park families and busy professionals — the salon comes to you. Skip the drive across the Buckman Bridge. Two monthly plans, unlimited visits, AI 3D nail art, spray tans, and same-day booking across Clay County.",
    whyCopy:
        "Between school runs, NAS Jax schedules, and the Fleming Island commute, driving to a nail salon in Jacksonville just isn't worth it. Our mobile studio pulls up to your driveway in Eagle Harbor, sets up in a spare room in Oakleaf Plantation, or joins a girls' night at your Doctors Inlet home — with everything a salon has, plus AI 3D nail art no salon can match.",
    neighborhoods: [
        "Eagle Harbor",
        "Oakleaf Plantation",
        "Fleming Island",
        "Doctors Inlet",
        "Ridgewood",
        "Lakeside",
        "Green Cove Springs",
        "Middleburg",
    ],
    nearby: ["Argyle Forest", "Julington Creek", "Bellair-Meadowbrook", "Asbury Lake"],
};

export default function OrangePark() {
    return <CityLanding city={CITY} />;
}
